<!-- =========================================================================================
  File Name: UserEdit.vue
  Description: User Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-edit">
    <vx-card v-if="user">
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs class="tab-action-btn-fill-conatiner">
          <vs-tab label="Conta" icon-pack="feather" icon="icon-user">
            <div class="tab-text">
              <user-edit-tab-account class="mt-4" :data="user" />
            </div>
          </vs-tab>
          <vs-tab label="Senha" icon-pack="feather" icon="icon-unlock">
            <div class="tab-text">
              <user-edit-tab-password class="mt-4" :data="user" />
            </div>
          </vs-tab>
          <!-- <vs-tab label="Information" icon-pack="feather" icon="icon-info">
            <div class="tab-text">
              <user-edit-tab-information class="mt-4" :data="user" />
            </div>
          </vs-tab>
          <vs-tab label="Social" icon-pack="feather" icon="icon-share-2">
            <div class="tab-text">
              <user-edit-tab-social class="mt-4" :data="user" />
            </div>
          </vs-tab>-->
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>

<script>
import axios from "axios";
import { baseApiUrl } from "@/global";
import UserEditTabAccount from "./UserEditTabAccount.vue";
import UserEditTabPassword from "./UserEditTabPassword.vue";
export default {
  components: {
    UserEditTabAccount,
    UserEditTabPassword,
  },
  data() {
    return {
      user: {},
    };
  },
  methods: {
    async loadUser() {
        try {
          this.$vs.loading();
          const response = await axios.get(
            `${baseApiUrl}/user/getUserById/${this.$route.params.idUser}`
          );
          this.user = response.data;
          this.user_not_found = false;
          this.$vs.loading.close();
        } catch (error) {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: "Não foi possivel carregar" + error,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        }
    },
    /*getUser(){
      this.user = this.$store.state.users.find(user => user.idUsuario == this.$route.params.Id)
    }*/
  },
  created() {
    this.loadUser();
  },
};
</script>
